import * as React from 'react'
import { ReactElement } from 'react'
import FileMessageForm from './FileMessageForm'
import FileMessageHeader from './FileMessageHeader'
import { makeStyles, shorthands, tokens } from '@fluentui/react-components'

export const usePageStyles = makeStyles({
    page: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalS,
        ...shorthands.padding(tokens.spacingHorizontalS),

        '@media screen and (max-width: 400px)': {
            ...shorthands.padding(tokens.spacingHorizontalXS),
        },
    },
    card: {
        padding: tokens.spacingHorizontalS,
    },
    container: {
        display: 'grid',
        gridTemplateColumns: '1fr 9fr 2fr',
        ...shorthands.gap(tokens.spacingHorizontalM, tokens.spacingVerticalS),
        ...shorthands.margin(0, 0),
        alignItems: 'center',
    },
    description: {
        display: 'grid',
    },
    datetime: {
        display: 'grid',
        textAlign: 'end',
    },
})

export default function FileMessage(): ReactElement {
    const pageStyles = usePageStyles()

    return (
        <div className={pageStyles.page}>
            <FileMessageHeader />
            <FileMessageForm />
        </div>
    )
}
